import styled from "@emotion/styled";

import { fontBarlow, fontPlayfairDisplay, theme } from "shared/lib/styles";

import QuoteIcon from "./icon-quote.svg";

export const StyledQuoteIcon = styled(QuoteIcon)`
  inline-size: 50px;
  block-size: 40px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 64px;
    block-size: 51px;
  }
`;

export const StyledFigure = styled.figure`
  margin-block: 64px;
  padding-inline: 16px;

  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 40px;
  }
`;

export const StyledBlockquote = styled.blockquote`
  margin-block-start: 20px;

  color: #000000;
  font-weight: 400;
  font-size: 22px;
  font-family: ${fontPlayfairDisplay};
  font-style: italic;
  line-height: 36px;
  letter-spacing: -0.22px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;

    font-size: 24px;
    line-height: 40px;
    letter-spacing: -0.24px;
  }
`;

export const StyledFigcaption = styled.figcaption`
  margin-block-start: 16px;

  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontBarlow};
  font-style: normal;
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;
  }
`;
